module.exports = {
  siteTitle: "Lucas Kjaero-Zhang's website",
  shortSiteTitle: "Lucas Kjaero-Zhang",
  siteDescription: "The official website of Lucas Kjaero-Zhang",
  siteUrl: "https://www.lucaskjaerozhang.com",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* info */
  headerTitle: "Lucas Kjaero-Zhang",
  headerSubTitle: "Technologist. Traveler.",

  /* manifest.json */
  manifestName: "The official website of Lucas Kjaero-Zhang",
  manifestShortName: "lkzhang", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [{ name: "github", url: "https://github.com/lucaskjaero" }],
};
